import * as React from 'react';
import { useEffect, useRef, useState } from 'react';
import { insertStringScript, removeErrorOnFocus } from "../../../common/util";
import FormTextInput from '../../FormComponents/formTextInput';
import { Field } from 'redux-form';
import InlineEditableField from '../../InlineEditableField';

const runPreScript = (id, preScript) => {
    insertStringScript(id, preScript);
};

const runPostScript = (id, postScript) => {
    insertStringScript(id, postScript);
};

const String = (props) => {
    const [text, setText] = useState(null);
    const isMounted = useRef(false);
    const prevDataRef = useRef();

    const renderOnCard = () => {
        let { data, showLabel = false, includeSpace = false, returnValueForBlank = "-" } = props;
        if (Array.isArray(data))
            data = data[0];
        const value = ((data && data.Value) ? (data.Value.toUpperCase()) + "" + (includeSpace ? " " : "") : returnValueForBlank);
        return (showLabel) ?
            (<li data-test={data.Label}><label>{data.Label || data.FieldGroup} </label>: <span>{value}</span></li>)
            :
            value
    };

    const renderOnGrid = () => {
        let { renderType, data, showLabel = false, preAppendComma = false, includeSpace = false, returnValueForBlank = "-" } = props;
        if (Array.isArray(data))
            data = data[0];
        const value = ((data && data.Value) ? (preAppendComma ? ', ' : '') + "" + (data.Value) + "" + (includeSpace ? " " : "") : returnValueForBlank);
        if (renderType.toLowerCase() === 'activity') {
            return (showLabel) ?
                (<li data-test={data.Label}><label>{data.Label}: </label>{value}</li>)
                :
                (<li data-test={value}>{value}</li>)
        } else if (renderType.toLowerCase() === 'workkard') {
            return (showLabel) ?
                (<li data-test={data.Label}><label>{data.Label} </label><span>{value}</span></li>)
                :
                value
        } else {
            return (showLabel) ?
                (<React.Fragment><label>{data.Label}: </label>{value}</React.Fragment>)
                :
                value
        }
    };

    const renderOnDetail = () => {
        let { renderType, data, showLabel = false, includeSpace = false, returnValueForBlank = "-" } = props;
        if (Array.isArray(data))
            data = data[0];
        const value = ((data && data.Value && data.Value.trim()) ? (data.Value) + "" + (includeSpace ? " " : "") : returnValueForBlank);
        if (renderType.toLowerCase() === 'activity') {
            if (showLabel) {
                return (<li data-test={data.Label}><label>{data.Label}</label>
                    { <InlineEditableField
                        type="string"
                        data={data}
                        fieldValue={value}
                        isCompositeField={false}
                        canEdit={props.canEditActivity}
                        removeErrorOnFocus={(e) => removeErrorOnFocus(e)}
                        updateField={(data) => props.updateActivityField(data)} />}

                </li>)
            } else {
                return (<li data-test={value}>{value}</li>)
            }
        } else if (renderType.toLowerCase() === 'workkard') {
            if (showLabel) {
                return (<li data-test={data.Label}>
                    <label data-field-label={props.isShowDetailOnPopUp ? data.FieldKey + "label_block" : data.FieldKey}>{data.Label} </label>
                    {(props.dragndrop || !props.isShowDetailOnPopUp)
                        ? (<span>{value}</span>)
                        : <InlineEditableField
                            type="string"
                            data={data}
                            fieldValue={value}
                            isCompositeField={false}
                            canEdit={props.canEditWorkkard}
                            removeErrorOnFocus={(e) => removeErrorOnFocus(e)}
                            updateField={(data) => props.updateWorkkardFieldInfo(data)} />
                    }      </li>);
            } else {
                return value;
            }
        } else {
            return (showLabel) ?
                (<React.Fragment><label>{data.Label}: </label>{value}</React.Fragment>)
                :
                value
        }
    };

    const renderOnCreate = () => {
        let { renderType, data, showLabel = false } = props;
        if (renderType.toLowerCase() === 'note') {
            return (showLabel) ?
                (<div data-field-key={data.FieldKey}>
                    <label required-field-Key={data.FieldKey}>{data.Label}{data.IsMandatory ? <span className="red">*</span> : ""} </label>
                    <div className="FieldBlock string">
                        <input type="text" id={data.FieldKey} name={data.FieldKey} placeholder={data.Label} maxLength={data.MaxLength != 0 && data.MaxLength} value={(text == null && data.Value != null && data.Value != '') ? setText(data.Value) : text} onFocus={(e) => removeErrorOnFocus(e)} onChange={(e) => { setText(e.target.value); props.onFieldValueChange(e.target) }} />
                        <span id={data.FieldKey + "errorBlock"} className="errorSelfMsg"></span>
                    </div>
                </div>)
                :
                (<div>{data.Value}</div>)
        }
        else {
            return (
                <Field
                    component={FormTextInput}
                    wrapperClass=""
                    className=""
                    formGroup="formGroup"
                    name={data[0].Name}
                    labeldivclass="wth-3"
                    //inputClass="wth-4"
                    type={data[0].FieldType}
                    isDisabled={data[0].IsNonEditable}
                    placeholder={!data[0].IsNonEditable ? data[0].Label : ""}
                    maxLength={data[0].MaxLength != 0 && data[0].MaxLength}
                    isRequired={data[0].IsRequired}
                    label={data[0].Label}
                    divClass="wth-4"

                />
            )
        }
    };

    useEffect(() => {
        const data = Array.isArray(props.data) ? props.data[0] : props.data;
        if (data && data.preInitScript) {
            // this.runPreScript(`preInitScript-${data.FieldKey}`,data.preInitScript);
            let interval = setInterval(() => {
                if (document.getElementById(data.FieldKey)) {
                    runPreScript(`preInitScript-${data.FieldKey}`, data.preInitScript);
                    clearInterval(interval);
                }
            }, 100)
        }
        if (data && data.PreSaveScript) {
            runPostScript(`preSaveScript-${data.FieldKey}`, data.PreSaveScript);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        const newData = Array.isArray(props.data) ? props.data[0] : props.data;
        if (!isMounted.current) {
            isMounted.current = true;
            prevDataRef.current = newData;
            return;
        }
        const oldData = prevDataRef.current;
        prevDataRef.current = newData;
        if (oldData && oldData.Id != newData.Id && props.renderType.toLowerCase() === 'note') {
            const oldPreInitScripts = document.querySelector(`script[id='preInitScript-${oldData.FieldKey}']`);
            const oldPreSaveScripts = document.querySelector(`script[id='preSaveScript-${oldData.FieldKey}']`);
            const newPreInitScript = newData.preInitScript;
            const newPreSaveScript = newData.PreSaveScript;
            if (oldPreInitScripts) {
                oldPreInitScripts.parentNode.removeChild(oldPreInitScripts);
            }
            if (oldPreSaveScripts) {
                oldPreSaveScripts.parentNode.removeChild(oldPreSaveScripts);
            }
            if (newPreInitScript) {
                runPreScript(`preInitScript-${newData.FieldKey}`, newPreInitScript);
            }
            if (newPreSaveScript) {
                runPostScript(`preSaveScript-${newData.FieldKey}`, newPreSaveScript);
            }
        }
    });

    switch (props.renderLocation.toLowerCase()) {
        case "card":
            return renderOnCard();
        case "grid":
            return renderOnGrid();
        case "detail":
            return renderOnDetail();
        case "create":
            return renderOnCreate();
    }
};

export default String;